import { useState } from 'react';
import { FlatList, StyleSheet, View } from 'react-native';
import { calcSizeForTv } from 'utils/index';

import EnvButton from './components/EnvButton';
import { DEV_ENVIRONMENTS, PROD_ENVIRONMENTS, QA_ENVIRONMENTS } from './utils/constants';

import Button from 'components/Button';
import Grid from 'components/Grid';

const EasterEggEnvs: React.FC = () => {
  const [envIndexSelected, setEnvIndexSelected] = useState<number>(2);
  const envTypes = [
    { name: 'PROD', children: PROD_ENVIRONMENTS },
    { name: 'QA', children: QA_ENVIRONMENTS },
    { name: 'DEV', children: DEV_ENVIRONMENTS },
  ];

  return (
    <View style={styles.root}>
      <View style={styles.header}>
        <FlatList
          data={envTypes}
          keyExtractor={(item) => item.name}
          renderItem={({ item, index }) => (
            <Button
              role="button"
              useTVFocus
              variant="solid"
              backgroundColor="transparent"
              style={{
                marginRight: calcSizeForTv(20),
                padding: calcSizeForTv(25),
                borderWidth: calcSizeForTv(3),
                borderColor: 'transparent',
                borderBottomColor: index === envIndexSelected ? 'white' : '#7A8CFF',
              }}
              textTransform="uppercase"
              textStyle={{
                fontSize: calcSizeForTv(20),
                lineHeight: calcSizeForTv(24),
                color: index === envIndexSelected ? 'white' : '#7A8CFF',
                textShadowColor: 'rgba(7, 13, 49, 0.7)',
                textShadowOffset: { width: 1, height: 1 },
              }}
              onPress={() => setEnvIndexSelected(index)}>
              {item.name}
            </Button>
          )}
          contentContainerStyle={styles.flatListContent}
          showsHorizontalScrollIndicator={false}
          horizontal
        />
      </View>
      <Grid
        data={envTypes[envIndexSelected].children}
        renderItem={(item) => (
          <EnvButton
            name={item.title}
            url={item.url}
            description={item.description}
            borderColor={item.borderColor}
          />
        )}
        numColumns={6}
        gap={calcSizeForTv(30)}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  root: {
    marginVertical: calcSizeForTv(50),
  },
  header: {
    borderBottomColor: '#7A8CFF',
    borderBottomWidth: 1,
    marginBottom: calcSizeForTv(10),
  },
  flatListContent: {
    paddingHorizontal: calcSizeForTv(20),
  },
});

export default EasterEggEnvs;
